// src/components/layout/PageLeaveConfirmModal.js
import React, { useContext, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { AppThemeContext } from '../../context/AppThemeContext';
import './PageLeaveConfirmModal.css';

function PageLeaveConfirmModal({
    show = false,
    reasons = [],
    onStay,
    onContinue
}) {
    const { theme } = useContext(AppThemeContext);
    const dark = theme === 'dark';
    const [dontShowAgain, setDontShowAgain] = useState(false);

    useEffect(() => {
        if (show) setDontShowAgain(false);
    }, [show]);

    return (
        <Modal
            show={show}
            onHide={onStay}
            centered
            contentClassName={`page-leave-modal ${dark ? 'bg-dark text-white' : ''}`}
        >
            <Modal.Header closeButton>
                <Modal.Title>Leave this page?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-2">
                    You have unsaved work on this page. Leaving will discard it.
                </p>
                {reasons.length > 0 && (
                    <ul className="page-leave-reasons mb-3">
                        {reasons.map((reason) => (
                            <li key={reason}>{reason}</li>
                        ))}
                    </ul>
                )}
                <Form.Check
                    type="checkbox"
                    id="page-leave-dont-show"
                    className="page-leave-dont-show"
                    label="Don't show this again"
                    checked={dontShowAgain}
                    onChange={(event) => setDontShowAgain(event.target.checked)}
                />
            </Modal.Body>
            <Modal.Footer className="page-leave-footer">
                <div className="page-leave-actions">
                    <Button variant={dark ? 'outline-light' : 'outline-secondary'} onClick={onStay}>
                        Stay
                    </Button>
                    <Button variant="danger" onClick={() => onContinue(dontShowAgain)}>
                        Continue
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default PageLeaveConfirmModal;
